export const weekRangeSameMonthStart_dMy = "aoa";
export const weekRangeSameMonthEnd_dMy = "boa";
export const weekRangeSameYearStart_dMy = "coa";
export const weekRangeSameYearEnd_dMy = "doa";
export const weekRangeDifferentYearsStart_dMy = "eoa";
export const weekRangeDifferentYearsEnd_dMy = "foa";
export const weekRangeSameMonthStart_Mdy = "goa";
export const weekRangeSameMonthEnd_Mdy = "hoa";
export const weekRangeSameYearStart_Mdy = "ioa";
export const weekRangeSameYearEnd_Mdy = "joa";
export const weekRangeDifferentYearsStart_Mdy = "koa";
export const weekRangeDifferentYearsEnd_Mdy = "loa";
export const weekRangeSameMonthStart_ydM = "moa";
export const weekRangeSameMonthEnd_ydM = "noa";
export const weekRangeSameYearStart_ydM = "ooa";
export const weekRangeSameYearEnd_ydM = "poa";
export const weekRangeDifferentYearsStart_ydM = "qoa";
export const weekRangeDifferentYearsEnd_ydM = "roa";
export const weekRangeSameMonthStart_yMd = "soa";
export const weekRangeSameMonthEnd_yMd = "toa";
export const weekRangeSameYearStart_yMd = "uoa";
export const weekRangeSameYearEnd_yMd = "voa";
export const weekRangeDifferentYearsStart_yMd = "woa";
export const weekRangeDifferentYearsEnd_yMd = "xoa";
export const weekRangeStartEnd = "yoa";
export const weekRangeWeekNumber = "zoa";
export const calendarMonthStandalone_January = "Aoa";
export const calendarMonthStandalone_February = "Boa";
export const calendarMonthStandalone_March = "Coa";
export const calendarMonthStandalone_April = "Doa";
export const calendarMonthStandalone_May = "Eoa";
export const calendarMonthStandalone_June = "Foa";
export const calendarMonthStandalone_July = "Goa";
export const calendarMonthStandalone_August = "Hoa";
export const calendarMonthStandalone_September = "Ioa";
export const calendarMonthStandalone_October = "Joa";
export const calendarMonthStandalone_November = "Koa";
export const calendarMonthStandalone_December = "Loa";
export const amLowercaseShort = "Moa";
export const pmLowercaseShort = "Noa";
export const amLowercase = "Ooa";
export const pmLowercase = "Poa";
export const amUppercaseShort = "Qoa";
export const pmUppercaseShort = "Roa";
export const amUppercase = "Soa";
export const pmUppercase = "Toa";
export const minute = "Uoa";
export const minuteShort = "Voa";
export const minuteLetter = "Woa";
export const userDateTimeFormat = "Xoa";
export const monthDayFormatDayFirst = "Yoa";
export const monthDayFormatMonthFirst = "Zoa";
export const monthDayWeekDayFormatDayFirst = "_oa";
export const monthDayWeekDayFormatMonthFirst = "$oa";
export const MMMM = "apa";
export const monthDayYearFormat = "bpa";
export const yyyy = "cpa";
export const H = "dpa";
export const MMM = "epa";
export const d = "fpa";
export const MM = "gpa";
export const dd = "hpa";
export const dayWeekDayFormat = "ipa";
export const hT = "jpa";
export const Th = "kpa";
export const timeSeparator = "lpa";
export const shortWeekDayMonthDayYearFormat = "mpa";
export const weekDayDateTimeFormat = "npa";
export const weekDayDateTimeWithAtFormat = "opa";
export const weekDayMonthDayFormat = "ppa";
export const weekDayMonthDayYearFormat = "qpa";
export const weekDayTimeFormat = "rpa";
export const yearMonthFormatYearFirst = "spa";
export const yearMonthFormatMonthFirst = "tpa";
export const M = "upa";
export const yy = "vpa";
export const h = "wpa";
export const hh = "xpa";
export const HH = "ypa";
export const m = "zpa";
export const mm = "Apa";
export const oneMinuteAgoText = "Bpa";
export const minutesAgoText = "Cpa";
export const yesterdayTime = "Dpa";
export const weekdayAtTime = "Epa";
export const oneHourAgoText = "Fpa";
export const hoursAgoText = "Gpa";
export const oneDayAgoText = "Hpa";
export const daysAgoText = "Ipa";
export const oneWeekAgoText = "Jpa";
export const weeksAgoText = "Kpa";
export const oneMonthAgoText = "Lpa";
export const monthsAgoText = "Mpa";
export const oneYearAgoText = "Npa";
export const yearsAgoText = "Opa";
export default {weekRangeSameMonthStart_dMy,weekRangeSameMonthEnd_dMy,weekRangeSameYearStart_dMy,weekRangeSameYearEnd_dMy,weekRangeDifferentYearsStart_dMy,weekRangeDifferentYearsEnd_dMy,weekRangeSameMonthStart_Mdy,weekRangeSameMonthEnd_Mdy,weekRangeSameYearStart_Mdy,weekRangeSameYearEnd_Mdy,weekRangeDifferentYearsStart_Mdy,weekRangeDifferentYearsEnd_Mdy,weekRangeSameMonthStart_ydM,weekRangeSameMonthEnd_ydM,weekRangeSameYearStart_ydM,weekRangeSameYearEnd_ydM,weekRangeDifferentYearsStart_ydM,weekRangeDifferentYearsEnd_ydM,weekRangeSameMonthStart_yMd,weekRangeSameMonthEnd_yMd,weekRangeSameYearStart_yMd,weekRangeSameYearEnd_yMd,weekRangeDifferentYearsStart_yMd,weekRangeDifferentYearsEnd_yMd,weekRangeStartEnd,weekRangeWeekNumber,calendarMonthStandalone_January,calendarMonthStandalone_February,calendarMonthStandalone_March,calendarMonthStandalone_April,calendarMonthStandalone_May,calendarMonthStandalone_June,calendarMonthStandalone_July,calendarMonthStandalone_August,calendarMonthStandalone_September,calendarMonthStandalone_October,calendarMonthStandalone_November,calendarMonthStandalone_December,amLowercaseShort,pmLowercaseShort,amLowercase,pmLowercase,amUppercaseShort,pmUppercaseShort,amUppercase,pmUppercase,minute,minuteShort,minuteLetter,userDateTimeFormat,monthDayFormatDayFirst,monthDayFormatMonthFirst,monthDayWeekDayFormatDayFirst,monthDayWeekDayFormatMonthFirst,MMMM,monthDayYearFormat,yyyy,H,MMM,d,MM,dd,dayWeekDayFormat,hT,Th,timeSeparator,shortWeekDayMonthDayYearFormat,weekDayDateTimeFormat,weekDayDateTimeWithAtFormat,weekDayMonthDayFormat,weekDayMonthDayYearFormat,weekDayTimeFormat,yearMonthFormatYearFirst,yearMonthFormatMonthFirst,M,yy,h,hh,HH,m,mm,oneMinuteAgoText,minutesAgoText,yesterdayTime,weekdayAtTime,oneHourAgoText,hoursAgoText,oneDayAgoText,daysAgoText,oneWeekAgoText,weeksAgoText,oneMonthAgoText,monthsAgoText,oneYearAgoText,yearsAgoText};